import {Badge, Box, Text} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import type {SolventRequirement} from './utils'

interface SolventRequirementsListProps {
  requirements: SolventRequirement[]
}

/** Read-only solvent lines shown instead of the solvent batch picker when the solvent stock check is skipped. */
export function SolventRequirementsList({requirements}: SolventRequirementsListProps) {
  const {t} = useTranslate('common')

  return (
    <Box
      flex="1"
      display="flex"
      flexDirection="column"
      borderColor="border"
      borderWidth="1px"
      borderRadius="md"
      paddingRight="3"
      paddingLeft="1"
      paddingBlock="1"
      minWidth="28rem"
      maxWidth="28rem"
      bg="white"
    >
      <Box
        display="flex"
        gap={1}
        alignItems="center"
        justifyContent="space-between"
        paddingInline="2"
        paddingBlock="1.5"
      >
        <Text fontSize="sm" fontWeight="medium">
          {t('solvents')}
        </Text>
        <Badge size="sm" colorPalette="gray">
          {t('solvent_no_stock_check')}
        </Badge>
      </Box>
      {requirements.map(requirement => (
        <Box
          key={requirement.solutionDrugId}
          display="flex"
          justifyContent="space-between"
          paddingInline="2"
          paddingBlock="1"
          borderTopWidth="1px"
          borderColor="border"
        >
          <Text fontSize="sm">{requirement.name}</Text>
          <Text fontSize="sm" fontWeight="medium">
            {requirement.amountMl} ml
          </Text>
        </Box>
      ))}
    </Box>
  )
}
